export const desktopMediaQuery = '(min-width:1024px)';
export const tabletMediaQuery = '(min-width:600px)';
export const mobileMediaQuery = '(max-width:599px)';
